<template>
  <div class="audioSettings">
    <div class="list">
      <van-cell >
        <div class="container">
          <div class="upload-button" @click="showAddImg">
            <img src="/static/images/program/updata.png" alt="Upload" class="upload-icon">
          </div>
          <div ref="audioSortList" class="scrollable-list">
            <div
              v-for="(item, index) in lists"
              :key="audioItemKey(item)"
              class="list-item audio-sort-item mp-sort-list-item"
              @contextmenu.prevent
            >
              <div class="delete-button" @click="dele(index)">
                <img src="/static/images/program/del.png">
              </div>
              <div class="image-container">
                <SortableListThumb
                  src="/static/images/program/msic.png"
                  :track-error="false"
                />
                <div class="scrolling-text" >
                  <span>{{ item.name }}</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </van-cell>
      <van-cell >
        <template #icon>
          <img src="/static/images/program/volume.png" style="height: 25px;margin-right: 10px;">
        </template>
        <span>{{$t('append_field.volume')}}</span>
        <div style="float: right;">
          <van-stepper v-model="volume" min="0" integer max="100" @change="setrolletime"></van-stepper>
        </div>
      </van-cell>
    </div>
    <MaterialPicker v-if="isImg" type="audio" @select="setVideos" @close="close" />
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import MaterialPicker from "@/components/MaterialPicker.vue";
import SortableListThumb from '@/components/SortableListThumb.vue'
import mpListSortableMixin from '@/mixins/mpListSortableMixin'
  export default {
    mixins: [mpListSortableMixin],
    props: {
      lists: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data() {
      return {
        volume: 70,
        period: false,
        isImg: false,
      }
    },
    mounted() {
      if(this.lists[0]){
        this.volume=this.lists[0].volume
      }
      this.$nextTick(() => {
        this.initMpListSortable()
      })
    },
    methods: {
      ...mapActions(['addAudios']),
      fullscreen() {
        this.$emit('fullscreen')
      },
      setrolletime: function (value) {
        this.componentsList[this.controlIndex].mpList.map(res => {
          res.volume = value
        })
      },

      dele(index) {
        this.$emit('ondele', index)
      },
      showAddImg() {
        this.isImg = true
      },
      setVideos(data) {
        this.addAudios(data)
        this.isImg = false
      },
      close() {
        this.isImg = false
      },
      clear() {
        this.$emit('clear')
      },
      audioItemKey(item) {
        return String(item.mid )
      },
    },
    components: { MaterialPicker, SortableListThumb },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
      mpListSortableConfig() {
        return {
          listRef: 'audioSortList',
          itemSelector: '.audio-sort-item',
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";
  @import "@/styles/mp-sort-list.scss";

  .audioSettings {
    .list {
      .van-cell ,.van-cell__value{
        display:flex ;
        align-items: center;
        justify-content: space-between;
      }
    }
    .container {
      display: flex;
      //height:60px;
      width: 100%;
    }

    .upload-button {
      position: sticky;
      left: 0;
      top: 0;
      width: 40px;
      height: 40px;
      background-color: white; /* 防止内容滚动时覆盖 */
      padding: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .upload-icon {
      width: 65px;
      height: 65px;
    }

    .scrollable-list {
      width: calc(100% - 50px);
      display: flex;
      overflow-x: auto;
      margin-left: 10px; /* 为了避免与固定的上传按钮重叠 */
    }
    .delete-button {
      align-self: flex-end;
      cursor: pointer;
      position: absolute; /* 绝对定位 */
      z-index: 2;
      top: 2px; /* 距离顶部5px */
      right: 2px;
      img{
        width: 20px;
        height: 20px;
      }
    }
    .list-item {
      position: relative; /* 使得内部的绝对定位元素相对于该元素定位 */
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 10px;
      .image-container {
        position: relative;

        .scrolling-text {
          position: absolute;
          bottom: 7px;
          left: 0;
          width: 100%;
          background: rgba(0, 0, 0, 0.5);
          color: white;
          overflow: hidden;
          white-space: nowrap;
          box-sizing: border-box;
        }

        .scrolling-text span {
          display: inline-block;
          animation: scroll-text 10s linear infinite;
        }

        @keyframes scroll-text {
          0% {
            transform: translateX(60px);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      }
    }


  }


</style>
